import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';

const Countdown: React.FC<{ heldUntil: string }> = ({ heldUntil }) => {
    const [timeLeft, setTimeLeft] = useState('');

    useEffect(() => {
        const calculateTimeLeft = () => {
            const heldUntilDate = dayjs(heldUntil);
            const now = dayjs();
            const diffInSeconds = heldUntilDate.diff(now, 'second');
            
            if (diffInSeconds <= 0) {
                return 'Reservation Expired';
            }

            const minutes = Math.floor(diffInSeconds / 60);
            const seconds = diffInSeconds % 60;
            return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        };

        setTimeLeft(calculateTimeLeft());
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, [heldUntil]);

    return <div>{timeLeft}</div>;
};

export default Countdown;
